type YandexMetrikaParams = {
  [key: string]: string | Record<string, string>;
};

const reachGoal = (target: string, params?: YandexMetrikaParams) => {
  const counterId = 99998859;

  if (typeof window !== "undefined" && "ym" in window) {
    if (params) {
      (window as any).ym(counterId, 'reachGoal', target, params);
    } else {
      (window as any).ym(counterId, 'reachGoal', target);
    }
  }
};

const reachGoalButtonClickGooglePlay = () => {
  reachGoal('button-click-google-play');
}

const reachGoalButtonClickGooglePlayNew = () => {
  reachGoal('button-click-google-play-new');
}

const reachGoalButtonClickAppStore = () => {
  reachGoal('button-click-appstore');
}

const reachGoalButtonClickAppStoreNew = () => {
  reachGoal('button-click-appstore-new');
}

const reachGoalButtonClickMoreDetails = () => {
  reachGoal('button-click-more-details');
}

const reachGoalButtonViewAppStoreNew = () => {
  reachGoal('saw-button', { 'Увидел кнопку': 'iOS' });
};

const reachGoalButtonViewGooglePlayNew = () => {
  reachGoal('saw-button', { 'Увидел кнопку': 'Android' });
};

const reachGoalButtonViewNotDetected = () => {
  reachGoal('saw-button', { 'Увидел кнопку': 'Не определена' });
};

const reachGoalButtonClickSlider = (partnerPromotion: string) => {
  reachGoal('button-click-slider', {'Слайдер': {'Кликнул': partnerPromotion}});
};

const reachRedirectToAppStore = () => {
  reachGoal('redirect-to-app-store');
}

const reachRedirectToGooglePlay = () => {
  reachGoal('redirect-to-google-play');
}

const reactOperatingSystemNotDetect = () => {
  reachGoal('operating-system-not-detect');
}

export const yandexMetrika = {
    reachGoalButtonClickGooglePlay,
    reachGoalButtonClickGooglePlayNew,
    reachGoalButtonClickAppStore,
    reachGoalButtonClickAppStoreNew,
    reachGoalButtonClickMoreDetails,
    reachGoalButtonViewAppStoreNew,
    reachGoalButtonViewGooglePlayNew,
    reachGoalButtonViewNotDetected,
    reachGoalButtonClickSlider,
    reachRedirectToAppStore,
    reachRedirectToGooglePlay,
    reactOperatingSystemNotDetect,
}
